import { getCallInfo, getEmailList, getSMSList } from './api/controller';
let authService;

export const setAuthService = auth => {
  if (!authService) {
    authService = auth;
    setInterval(() => {
      authService.updateAuthState();
    }, 600 * 1000);
    authService.on('authStateChange', (...args) => {
      console.log('authState updated');
    });
  }
};

export const updateAuth = async () => {
  await authService.updateAuthState();
};
export const toJSONObj = str => {
  let result;

  try {
    result = JSON.parse(str);
  } catch (e) {
    result = null;
  }

  return result;
};

export const toJSONString = obj => {
  let result;

  try {
    result = JSON.stringify(obj);
  } catch (e) {
    result = null;
  }

  return result;
};

export function mergeClasses() {
  let result = '';
  let args = Array.prototype.slice.call(arguments);
  args.forEach(element => {
    result += element + ' ';
  });

  return result.trim();
}

export const displayTimestamp = timestamp => {
  if (typeof timestamp !== 'number') {
    console.error(
      'Invalid time format. Expected number but received  ',
      typeof timestamp,
      time
    );
    return 'Error In Number Format';
  }
  let time = new Date(timestamp);

  let strArr = time
    .toString()
    .split(' ')
    .slice(0, 5);

  strArr[3] = strArr[3] + ',';
  strArr[4] = time.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  return strArr.join(' ');
};

export const getOktaHeader = method => {
  // const { accessToken } = JSON.parse(
  //   localStorage.getItem('okta-token-storage')
  // ).accessToken;

  const { accessToken } = authService.getAuthState();
  let headers = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  if (method) {
    headers.method = method;
  }

  return headers;
};

export const logout = () => {
  localStorage.removeItem('env');
  localStorage.removeItem('enable-achieve-okta');
  sessionStorage.clear();
  window.authService.logout();
};

export const refreshToken = async auth => {
  let res = await auth._oktaAuth.token
    .getWithoutPrompt({
      pkce: true,
      scopes: ['openid', 'email', 'profile', 'offline_access'],
      responseType: ['code'],
    })
    .catch(err => {
      console.log('Refresh Error', err);
      return [, , err];
    });
  let [accessToken, idToken, err] = res;
  console.log('Refresh Res', res);

  let newTokenStorage = { accessToken, idToken };

  localStorage.setItem('okta-token-storage', JSON.stringify(newTokenStorage));

  return newTokenStorage;
};

export const conditionalRefresh = () => {
  if (
    localStorage.getItem(
      'okta-token-storage'
    ) /* checking if logged in at the beginning */
  ) {
    refreshToken(auth);
  } else {
    clearInterval(window.refreshInterval);

    window.authService.logout();
  }
};

export const autoRefreshToken = async auth => {
  // window.refreshInterval = window.refreshInterval =
  //   window.refreshInterval ||
  //   setInterval(conditionalRefresh(auth), 1000 * 60 * 25);
};

export const timerFormatter = data => {
  if (!data) {
    return 'now';
  }
  const now = Number(new Date());
  const start = Number(new Date(data.start));

  const diff = Math.abs(Math.floor((now - start) / 1000));

  let hour, minute, second;

  second = diff % 60;
  hour = Math.floor(diff / (60 * 60));
  minute = Math.floor((diff % (60 * 60)) / 60);

  return `${hour ? `${hour}h ` : ''}${hour || minute ? `${minute}m ` : ''}${
    hour ? '' : second + 's'
  }`;
};

export const localTimeFormatter = offset => {
  let time = new Date();
  if (typeof offset === 'number' && (offset || offset === 0)) {
    const localOffset = time.getUTCHours() - time.getHours();
    time.setHours(time.getHours() + (localOffset + offset));
  }

  let hour = time.getHours();
  let minute = time.getMinutes();
  let ampm = 'AM';
  if (hour > 11) {
    ampm = 'PM';
    hour = hour % 12;
    if (hour === 0) {
      hour = 12;
    }
  }
  hour = hour.toString();
  minute = minute.toString();

  if (hour.length === 1) {
    hour = '0' + hour;
  }

  if (minute.length === 1) {
    minute = '0' + minute;
  }
  return `${hour}:${minute} ${ampm}`;
};

export const formatPath = path => {
  let newPath = path
    .split('.')
    .map(item => {
      return item.replace('{', '').replace('}', '');
    })
    .join('.');

  return newPath;
};
export const parseJSONPath = (obj, path, component) => {
  let val = jsonPath(obj, path);

  if (val === false) {
    console.warn('Could not parse value from path');
    return undefined;
  }

  return val[0];
};

export function jsonPath(obj, expr, arg) {
  /* JSONPath 0.8.0 - XPath for JSON
   *
   * Copyright (c) 2007 Stefan Goessner (goessner.net)
   * Licensed under the MIT (MIT-LICENSE.txt) licence.
   */
  var P = {
    resultType: (arg && arg.resultType) || 'VALUE',
    result: [],
    normalize: function(expr) {
      var subx = [];
      return expr
        .replace(/[\['](\??\(.*?\))[\]']/g, function($0, $1) {
          return '[#' + (subx.push($1) - 1) + ']';
        })
        .replace(/'?\.'?|\['?/g, ';')
        .replace(/;;;|;;/g, ';..;')
        .replace(/;$|'?\]|'$/g, '')
        .replace(/#([0-9]+)/g, function($0, $1) {
          return subx[$1];
        });
    },
    asPath: function(path) {
      var x = path.split(';'),
        p = '$';
      for (var i = 1, n = x.length; i < n; i++)
        p += /^[0-9*]+$/.test(x[i]) ? '[' + x[i] + ']' : "['" + x[i] + "']";
      return p;
    },
    store: function(p, v) {
      if (p)
        P.result[P.result.length] = P.resultType == 'PATH' ? P.asPath(p) : v;
      return !!p;
    },
    trace: function(expr, val, path) {
      if (expr) {
        var x = expr.split(';'),
          loc = x.shift();
        x = x.join(';');
        if (val && val.hasOwnProperty(loc))
          P.trace(x, val[loc], path + ';' + loc);
        else if (loc === '*')
          P.walk(loc, x, val, path, function(m, l, x, v, p) {
            P.trace(m + ';' + x, v, p);
          });
        else if (loc === '..') {
          P.trace(x, val, path);
          P.walk(loc, x, val, path, function(m, l, x, v, p) {
            typeof v[m] === 'object' && P.trace('..;' + x, v[m], p + ';' + m);
          });
        } else if (/,/.test(loc)) {
          // [name1,name2,...]
          for (var s = loc.split(/'?,'?/), i = 0, n = s.length; i < n; i++)
            P.trace(s[i] + ';' + x, val, path);
        } else if (/^\(.*?\)$/.test(loc))
          // [(expr)]
          P.trace(
            P.eval(loc, val, path.substr(path.lastIndexOf(';') + 1)) + ';' + x,
            val,
            path
          );
        else if (/^\?\(.*?\)$/.test(loc))
          // [?(expr)]
          P.walk(loc, x, val, path, function(m, l, x, v, p) {
            if (P.eval(l.replace(/^\?\((.*?)\)$/, '$1'), v[m], m))
              P.trace(m + ';' + x, v, p);
          });
        else if (/^(-?[0-9]*):(-?[0-9]*):?([0-9]*)$/.test(loc))
          // [start:end:step]  phyton slice syntax
          P.slice(loc, x, val, path);
      } else P.store(path, val);
    },
    walk: function(loc, expr, val, path, f) {
      if (val instanceof Array) {
        for (var i = 0, n = val.length; i < n; i++)
          if (i in val) f(i, loc, expr, val, path);
      } else if (typeof val === 'object') {
        for (var m in val)
          if (val.hasOwnProperty(m)) f(m, loc, expr, val, path);
      }
    },
    slice: function(loc, expr, val, path) {
      if (val instanceof Array) {
        var len = val.length,
          start = 0,
          end = len,
          step = 1;
        loc.replace(/^(-?[0-9]*):(-?[0-9]*):?(-?[0-9]*)$/g, function(
          $0,
          $1,
          $2,
          $3
        ) {
          start = parseInt($1 || start);
          end = parseInt($2 || end);
          step = parseInt($3 || step);
        });
        start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
        end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
        for (var i = start; i < end; i += step)
          P.trace(i + ';' + expr, val, path);
      }
    },
    eval: function(x, _v, _vname) {
      try {
        return $ && _v && eval(x.replace(/@/g, '_v'));
      } catch (e) {
        throw new SyntaxError(
          'jsonPath: ' +
            e.message +
            ': ' +
            x.replace(/@/g, '_v').replace(/\^/g, '_a')
        );
      }
    },
  };

  var $ = obj;
  if (expr && obj && (P.resultType == 'VALUE' || P.resultType == 'PATH')) {
    P.trace(P.normalize(expr).replace(/^\$;/, ''), obj, '$');
    return P.result.length ? P.result : false;
  }
}

// Get only the date from Timestamp
export const dateOnly = timeStamp => {
  if (typeof timeStamp !== 'number') {
    console.error(
      'Invalid time format. Expected number but received  ',
      typeof timeStamp
    );
    return 'Error In Number Format';
  }

  let date = new Date(timeStamp).toDateString().split(' ');
  return `${date[1]} ${date[2]}, ${date[3]}`;
};

export const sortByAge = (factor = 1) => (a, b) => {
  let aComp = Number(new Date(a.updated_at)) || Number(new Date(a.updated_at));
  let bComp = Number(new Date(b.updated_at)) || Number(new Date(b.updated_at));

  if (aComp < bComp) {
    return factor * -1;
  }

  if (aComp > bComp) {
    return factor * 1;
  }

  if (aComp === bComp) {
    return 0;
  }

  console.error('Unable to compare');
  return 0;
};

export const sortByWeight = (factor = 1) => (taskA, taskB) => {
  // sort rule
  // 1 call type over other types
  // 2 assigned status over other statuses. (basically task over offer)
  // 3 then by weight then updatedAt
  // Note, no asc/desc on type/status
  const typeA = taskA.type.toLowerCase() === 'call' ? 1 : 0;
  const typeB = taskB.type.toLowerCase() === 'call' ? 1 : 0;

  const statusA = taskA.status.toLowerCase() === 'assigned' ? 1 : 0;
  const statusB = taskB.status.toLowerCase() === 'assigned' ? 1 : 0;

  // NOTE, due to omitempty weight on offer obj can be undefined, use 0 as the default weight
  const weightA =
    (taskA.distribution_info?.weight === undefined
      ? taskA.weight
      : taskA.distribution_info?.weight) || 0;
  const weightB =
    (taskB.distribution_info?.weight === undefined
      ? taskB.weight
      : taskB.distribution_info?.weight) || 0;

  const updatedAtA = Number(new Date(taskA.updated_at));
  const updatedAtB = Number(new Date(taskB.updated_at));

  if (typeA === typeB && statusA === statusB) {
    return factor * (weightA - weightB || updatedAtA - updatedAtB);
  }

  if (typeA === typeB) {
    return -1 * (statusA - statusB);
  }
  return -1 * (typeA - typeB);
};

export const getTaskByCallInfo = (callInfo, tasks) => {
  let callId = callInfo.call_id || callInfo.id;
  let taskId = callInfo.task_id || callInfo.taskId;

  let res = tasks.find(task => {
    if (!task) return;
    if (callInfo.direction && callInfo.direction.toLowerCase() === 'inbound') {
      let condition = taskId
        ? taskId === task.id
        : task.call &&
          ((task.call.id && task.call.id.toString() === callId.toString()) ||
            callInfo.task_id === task.id);

      if (condition) {
        return true;
      }
    }

    if (callInfo.direction && callInfo.direction.toLowerCase() === 'outbound') {
      if (
        (taskId && taskId === task.id) ||
        (task.call && task.call.id === callId) ||
        (task.call &&
          task.call.direction.toLowerCase === 'outbound' &&
          task.call.called === callInfo.called &&
          task.call.caller === callInfo.caller)
      ) {
        return true;
      }
    }

    if (callId) {
      if (task.call && task.call.id === callId) {
        return true;
      }
    }
    if (taskId) {
      if (task.id === taskId) {
        return true;
      }
    }
  });

  if (!res) console.error('Task Not Found', callInfo, tasks);

  return res;
};

export const getTaskIndexByTaskId = (taskId, tasks) => {
  let index = -1;
  tasks.forEach((task, i) => {
    if (task && task.id === taskId) {
      index = i;
    }
  });
  if (index < 0) {
    console.warn('Could not find task by Id', taskId);
  }
  return index;
};

export const getTaskByTaskId = (taskId, tasks) => {
  return tasks.find(task => {
    return task && task.id === taskId;
  });
};

export const getWrapupMessageFromLocalByTaskId = taskId => {
  return JSON.parse(localStorage.getItem(taskId) || '{}');
};

export const setWrapupMessageToLocalByTaskId = (taskId, fieldId, message) => {
  let wrapupMessages = JSON.parse(localStorage.getItem(taskId) || '{}');

  wrapupMessages[fieldId] = message;
  localStorage.setItem(taskId, JSON.stringify(wrapupMessages));
};

export const getArchiveQuery = args => {
  const { date, offset, limit } = args;
  let dt, createdAtFrom, createdAtTo;
  if (date) {
    dt = new Date(date);
  } else {
    dt = new Date(Date());
  }
  createdAtFrom = Date.parse(dt.toDateString());
  createdAtTo = createdAtFrom + 24 * 60 * 60 * 1000;
  const query = `?offset=${offset ? offset : 0}&limit=${limit ? limit : 20}${
    createdAtFrom ? `&created_at_from=${createdAtFrom}` : ''
  }${createdAtTo ? `&created_at_to=${createdAtTo}` : ''}`;
  console.log('Fetch Archive query: ', query);
  return query;
};

export const getSessionStatus = () => {
  const expiresAt = JSON.parse(localStorage.getItem('okta-token-storage'))
    .accessToken.expiresAt;

  const now = Math.round(Date.now() / 1000);
  const count = sessionStorage.getItem('count');

  if (now < expiresAt && count == 0) {
    return true;
  }
};

// Time display format for recordings
export const timeFormat = timeStamp => {
  if (typeof timeStamp !== 'number') {
    console.error(
      'Invalid time format. Expected number but received  ',
      typeof timeStamp
    );
    return 'Error In Number Format';
  }

  const dt = new Date(timeStamp);
  const year = dt.getFullYear();
  const month = (1 + dt.getMonth()).toString().padStart(2, '0');
  const day = dt
    .getDate()
    .toString()
    .padStart(2, '0');

  const tz = dt
    .toTimeString('en-US')
    .split('(')
    .slice(1, 2);
  const zone =
    tz[0]
      .split(' ')
      .map(el => el[0])
      .slice(0, 1) +
    tz[0]
      .split(' ')
      .map(el => el[0])
      .slice(2);
  const time = dt.toLocaleTimeString('en-US');

  return `${month}/${day}/${year} ${time} ${zone}`;
};

export const getClicked = sms => {
  let clicked = sms
    ? localStorage.getItem('smsClicked')
    : localStorage.getItem('clicked');
  if (clicked) {
    return JSON.parse(clicked);
  } else {
    return {};
  }
};

export const setClicked = (clicked, sms) => {
  sms
    ? localStorage.setItem('smsClicked', JSON.stringify(clicked))
    : localStorage.setItem('clicked', JSON.stringify(clicked));
};

export const getCurrentCallId = (tasks, userState) => {
  let list = [];
  tasks.forEach(task => {
    if (task && task.call_info && task.call_info.participants) {
      task.call_info.status !== 'completed' &&
        task.call_info.participants.forEach(participant => {
          if (
            participant.id === userState.id &&
            participant.status === 'connected'
          ) {
            list.push(task.call.id);
          }
        });
    }
  });

  if (list.length > 1) {
    console.error('For some reason, you are now connected to 2 calls', list);
  }

  return list;
};

export const swapCallsInLocalStorage = (fromCallId, toCallId) => {
  let swapCallsList = localStorage.getItem('swapCallsList') || '[]';
  let list = JSON.parse(swapCallsList);
  let index = list.indexOf(toCallId);
  if (index > -1) {
    list.splice(index, 1);
  }

  if (list.indexOf(fromCallId) < 0) {
    list.push(fromCallId);
  }

  localStorage.setItem('swapCallsList', JSON.stringify(list));
};

export const isCallsSwappedOnHoldLocalStorage = callId => {
  let swapCallsList = localStorage.getItem('swapCallsList');

  if (swapCallsList) {
    let list = JSON.parse(swapCallsList);

    let index = list.indexOf(callId);
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const updateTask = (task, taskState, dispatch) => {
  let index = getTaskIndexByTaskId(task.id, taskState.tasks);

  if (index) {
    taskState.tasks.splice(index, 1);
    dispatch({
      type: 'UPDATE_TASKS',
      taskState: {
        ...taskState,
      },
    });
  }
};

export const getCallErrorMsgById = (callId, callError) => {
  let errorObj;
  (callError || []).map(item => {
    item[callId] && item[callId].callId === callId && (errorObj = item[callId]);
  });

  return errorObj && errorObj;
};

export const errorTypeMapping = type => {
  let errMsg;
  switch (type && type.toLowerCase()) {
    case 'canceled':
      errMsg = 'Call canceled';
      break;
    case 'failed':
      errMsg = 'Error, call failed';
      break;
    case 'busy':
      errMsg = 'Busy signal detected';
      break;
    case 'no-answer':
      errMsg = 'Error, no answer';
      break;
    case 'client-hung-up':
      errMsg = 'Client hung up';
      break;
    case 'suppressed':
    case 'call-suppressed':
      errMsg = 'Voice call suppressed';
      break;
    default:
      errMsg = `Unknown Error${type && ', code: ' + type}`;
      break;
  }

  return errMsg;
};

export const getCurrentParticipants = (call, events, userState) => {
  let currentEvent = events[call.id];
  if (!call) {
    console.log('Could not find events for call. Call does not exist', call);
    return [];
  }
  if (!currentEvent) {
    console.log('Could not find events for call', call.id);
    return [];
  }

  if (currentEvent.callEnded) {
    return [];
  }

  let callDirection = call.direction;

  let typeKey = currentEvent.events[0].type ? 'type' : 'event_type';

  currentEvent.events.sort((a, b) => {
    return a.created_at - b.created_at;
  });
  let participants = new Set();
  let deleteSet = new Set([
    'participant-leave',
    'call-ended',
    'failed',
    'busy',
  ]);
  let addSet = new Set(['initiated', 'ringing', 'participant-join']);
  let participantMap = {};
  if (callDirection.toLowerCase() === 'inbound') {
    if (call.participants) {
      call.participants.forEach(participant => {
        if (participant.number === call.caller) {
          participantMap[participant.number] = participant.id;
        }
      });
    }
  }

  if (participantMap[call.caller]) {
    participants.add(participantMap[call.caller]);
  }

  currentEvent.events.forEach(event => {
    if (deleteSet.has(event[typeKey])) {
      let user = event.user_id ? event.user_id : null;

      if (user) {
        participants.delete(user);
      }
    }

    if (addSet.has(event[typeKey])) {
      let user = event.user_id ? event.user_id : null;

      if (user) {
        participants.add(user);
      }
    }
  });

  if (call.participants) {
    call.participants.forEach(part => {
      participants.add(part.id);
    });
  }

  return Array.from(participants);
};

export const isRinging = (eventsObj, call, userState) => {
  let currentEvent = eventsObj[call.id];

  if (!call) {
    console.log('Could not find events for call. Call does not exist', call);
    return;
  }
  if (!currentEvent) {
    console.log('Could not find events for call', call.id);
    return false;
  }

  if (currentEvent.callEnded) {
    return false;
  }
  let failSet = new Set(['participant-leave', 'call-ended', 'failed', 'busy']);
  let successSet = new Set(['initiated', 'ringing']);
  const { events } = currentEvent;

  let ringing = false;
  let notRinging = false;

  for (let i = 0; i < events.length; i++) {
    let event = events[i];

    let eventType = event.type || event.event_type;

    if (ringing) {
      if (failSet.has(eventType) && userState.id === event.user_id) {
        notRinging = true;
      }
    } else {
      if (successSet.has(eventType) && userState.id === event.user_id) {
        ringing = true;
      }

      if (failSet.has(eventType) && userState.id === event.user_id) {
        notRinging = true;
      }

      if (eventType === 'conference-start') {
        ringing = true;
      }
    }
  }

  return ringing && !notRinging;
};

export const getUserLogoutalertMsg = (tasks, user_id) => {
  let msg;

  tasks &&
    tasks.find(task => {
      task.call_info &&
        task.call_info.status === 'active' &&
        task.call_info.participants &&
        task.call_info.participants.find(participant => {
          participant.id === user_id &&
            (participant.status.toLowerCase() === 'connected'
              ? (msg = 'You cannot logout while on a call')
              : (msg = 'You cannot logout pending a call'));
        });
    });

  return msg;
};

export const participantInCall = (events, user_id) => {
  let lastIndexJoin = -1;
  let lastIndexLeft = -1;

  events.forEach((event, index) => {
    let type = 'type' in event ? 'type' : 'event_type';

    if (event[type] === 'participant-leave' && event.user_id === user_id) {
      lastIndexLeft = index;
    }

    if (event[type] === 'participant-join' && event.user_id === user_id) {
      lastIndexJoin = index;
    }
  });

  return lastIndexJoin > lastIndexLeft;
};

export const isOkayToSwapCall = ({ events, tasks, callError, id }) => {
  let keys = Object.keys(events);
  let activeEvents = [];
  let callErrorExist = false;
  for (let i = 0; i < keys.length; i++) {
    let call_id = keys[i];
    let event = events[call_id];

    let shouldAdd = tasks.find(task => {
      callError.forEach(errorObj => {
        if (
          task.call_info &&
          task.call_info.status === 'active' &&
          task.call_info.id !== undefined &&
          task.call_info.id in errorObj
        ) {
          callErrorExist = true;
        }
      });

      return (
        task &&
        task.call_info &&
        task.call_info.status === 'active' &&
        (task.id === event.task_id || (event.task && task.id === event.task.id))
      );
    });

    if (shouldAdd) {
      activeEvents.push(event);
    }
  }

  if (activeEvents.length === 1) {
    return true;
  }

  let count = 0;

  activeEvents.forEach(callEvents => {
    const { events } = callEvents;

    let isParticipantInCall = participantInCall(events, id);

    if (isParticipantInCall) {
      count++;
    }
  });

  if (count === 1 || callErrorExist) {
    return true;
  }

  return false;
};

export const setErrorClickedInLocalStorage = call_id => {
  let errors = JSON.parse(localStorage.getItem('call_errors') || '{}');

  errors[call_id] = true;

  localStorage.setItem('call_errors', JSON.stringify(errors));
};

export const getErrorClickedInLocalStorage = () => {
  return JSON.parse(localStorage.getItem('call_errors') || '{}');
};

export const removeErrorClickedInLocalStorage = call_id => {
  let errors = JSON.parse(localStorage.getItem('call_errors') || '{}');

  if (call_id in errors) {
    delete errors[call_id];
  }
  localStorage.setItem('call_errors', JSON.stringify(errors));
};

export const getCurrentCallIdsWithEvents = (taskState, userState) => {
  const { events, tasks, callError } = taskState;

  let keys = Object.keys(events);
  let activeCallTasks = [];

  for (let i = 0; i < keys.length; i++) {
    let call_id = keys[i];
    let event = events[call_id];

    tasks.forEach(task => {
      if (
        task &&
        task.call_info &&
        task.call_info.status === 'active' &&
        (task.id === event.task_id || (event.task && task.id === event.task.id))
      ) {
        activeCallTasks.push(task);
      }
    });
  }

  let activeEvents = activeCallTasks.map(task => {
    return [events[task.call_info.id], task.call_info.id];
  });

  let activeCallIds = [];

  activeEvents.forEach(([callEvents, call_id]) => {
    const { events } = callEvents;

    let isParticipantInCall = participantInCall(events, userState.id);

    if (isParticipantInCall) {
      activeCallIds.push(call_id);
    }
  });

  return activeCallIds;
};

export const getDuration = ({ fromTimestamp, toTimestamp }) => {
  if (!fromTimestamp || !toTimestamp) {
    console.error('Timestamp not received');
  }
  const fromTS = new Date(fromTimestamp);
  const toTS = new Date(toTimestamp);

  const duration = Math.abs(Math.floor((toTS - fromTS) / 1000));

  let second = duration % 60;

  return `${second + 's'}`;
};

export const getTaskList = ({ tasks, archived, filterTaskType }) => {
  switch ((filterTaskType || '').toUpperCase()) {
    case 'TASKS':
      return tasks || [];
    case 'ARCHIVED':
      return archived || [];
    case 'CALL':
      return (tasks || []).filter(
        task =>
          task.type.toUpperCase() === 'CALL' ||
          task.type.toUpperCase() === 'FREE_FORM_CALL' ||
          task.type.toUpperCase() === 'COACHING' ||
          task.type.toUpperCase() === 'MISSEDCALL' ||
          task.type.toUpperCase() === 'VOICEMAIL'
      );
    case 'DIRECT':
      return (tasks || []).filter(
        task =>
          (
            (task.distribution_info || {}).distribution_type || ''
          ).toUpperCase() === 'DIRECT'
      );
    case 'SMS':
      return (tasks || []).filter(task => task.type.toUpperCase() === 'SMS');
    case 'EMAIL':
      return (tasks || []).filter(task => task.type.toUpperCase() === 'EMAIL');

    default:
      return tasks || [];
  }
};

export const groupMessagesByDate = array => {
  return array.reduce((result, currentValue) => {
    (result[dateOnly(currentValue.created_at)] =
      result[dateOnly(currentValue.created_at)] || []).push(currentValue);
    return result;
  }, {});
};

export const groupRecipientsByType = array => {
  return array.reduce((result, currentValue) => {
    (result[(currentValue.type || '').toLowerCase()] =
      result[(currentValue.type || '').toLowerCase()] || []).push(currentValue);
    return result;
  }, {});
};

const getWrapupFieldTypes = obj => {
  let types = [];
  for (const [key, value] of Object.entries(obj || {})) {
    Array.isArray(value) ? types.push(value) : types.push(key);
  }
  return types.flat();
};

export const hasUnknownWrapUp = ({ wrap_up, wrapup_fields }) => {
  return (
    getWrapupFieldTypes(wrap_up || {}).filter(
      item => !(wrapup_fields.map(item => item.id) || []).includes(item)
    ) || []
  ).length;
};

export const getImagesList = html => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const imgs = [];
  Array.from(doc.getElementsByTagName('img')).forEach(img => {
    imgs.push({ src: img.src, text: img.alt || 'cannot be loaded' });
  });
  return imgs;
};

export const completeTaskData = async (taskList = []) => {
  const tasks = await Promise.all(
    taskList.map(async t => {
      try {
        switch (t.type.toUpperCase()) {
          case 'COACHING':
          case 'FREE_FORM_CALL':
          case 'CALL': {
            if (t.call_info) return t;
            if (!(t.call || {}).id) return t;
            const call_info = await getCallInfo(t.call.id);
            return { ...t, call_info };
          }
          case 'SMS': {
            if (t.sms_list) {
              return t;
            }
            const sms_list = await getSMSList(t.id);
            return { ...t, sms_list };
          }
          case 'EMAIL': {
            if (t.email_list) {
              return t;
            }
            const email_list = await getEmailList(t.id);
            return { ...t, email_list };
          }
          default:
            return t;
        }
      } catch (err) {
        console.error(err);
        return t;
      }
    })
  );
  return tasks;
};

export const scrollToRef = (node, offset) => {
  if (!node.parentNode) {
    return;
  }
  node.parentNode.scrollTop =
    node.offsetTop - node.parentNode.offsetTop + (offset > 0 ? offset : 0);
};

export const formatTime = seconds => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.round(seconds % 60);
  return [h, m > 9 ? m : h ? '0' + m : m || '0', s > 9 ? s : '0' + s]
    .filter(Boolean)
    .join(':');
};

export const sortByKey = (array, key, orderby) => {
  const order = orderby === 'dsc' ? -1 : 1;
  return array.sort((a, b) => {
    const keyA = (a[key] || '').toUpperCase();
    const keyB = (b[key] || '').toUpperCase();
    if (keyA < keyB) {
      return order * -1;
    }
    if (keyA > keyB) {
      return order * 1;
    }

    return 0;
  });
};

export const getMetricsRange = from => {
  const today = Math.floor(Date.parse(new Date(Date()).toDateString()) / 1000);
  const DAY_IN_SECONDS = 24 * 60 * 60;
  const to = today > from.seconds ? from.seconds + DAY_IN_SECONDS : undefined;
  return { from, ...(to && { to: { seconds: to } }) };
};

export const removeDuplicate = (array, key) => {
  return [...new Map(array.map(arr => [key(arr), arr])).values()];
};

export const strTemplateRenderer = (template, idx, ...args) => {
  if (!template) {
    return (args || []).join(', ');
  }
  const regExp = new RegExp(`{{\\\$idx}}`, 'g');
  let text = template.replace(regExp, idx.toString());
  (args || []).forEach((v, i) => {
    const regExp = new RegExp(`{{\\\$${i + 1}}}`, 'g');
    text = text.replace(regExp, `${v}`);
  });
  return text;
};

const trRegExp = /^((?<amount>\d+)|(?<current>\/))(?<unit>[mhdwMy])$/;
export const timeRangeParser = (range = '/d') => {
  const from = new Date();
  const res = trRegExp.exec(range);
  const config = res ? res.groups : { amount: 1, unit: 'd' };
  config.current = !!config.current;
  if (config.amount) {
    config.amount = parseInt(config.amount, 10);
  }
  config.amount = config.amount || 1;
  config.unit = config.unit || 'd';

  if (config.current) {
    switch (config.unit) {
      case 'y':
        from.setMonth(0, 1);
        from.setHours(0, 0, 0, 0);
        break;
      case 'M':
        from.setDate(1);
        from.setHours(0, 0, 0, 0);
        break;
      case 'w':
        from.setDate(from.getDate() - (from.getDay() || 7) + 1);
        from.setHours(0, 0, 0, 0);
        break;
      case 'd':
        from.setHours(0, 0, 0, 0);
        break;
      case 'h':
        from.setMinutes(0, 0, 0);
        break;
      case 'm':
        from.setSeconds(0, 0);
        break;
    }
  } else {
    switch (config.unit) {
      case 'y':
        from.setFullYear(from.getFullYear() - config.amount);
        break;
      case 'M':
        from.setMonth(-config.amount);
        break;
      case 'w':
        from.setDate(from.getDate() - 7 * config.amount);
        break;
      case 'd':
        from.setDate(from.getDate() - config.amount);
        break;
      case 'h':
        from.setHours(from.getHours() - config.amount);
        break;
      case 'm':
        from.setMinutes(from.getMinutes() - config.amount);
        break;
    }
  }

  return {
    from: {
      seconds: Math.floor(from.getTime() / 1000),
    },
  };
};

export const secondsToTime = (secs = 0) => {
  if (secs < 0) {
    secs = 0;
  }
  const ss = secs % 60;
  const mm = Math.floor(secs / 60);
  const hh = Math.floor(secs / 3600);

  return `${hh < 10 ? '0' + hh : hh}:${mm < 10 ? '0' + mm : mm}:${
    ss < 10 ? '0' + ss : ss
  }`;
};

export const parseMetricValue = (v = 0, type) => {
  switch (type) {
    case 'time':
      return secondsToTime(v);
    case 'min':
      return Math.round((10 * v) / 6) / 100;
    case 'hour':
      return Math.round(v / 36) / 100;
    default:
      return v;
  }
};

export const buildArchiveQuery = ({
  taskIds,
  createdAtFrom,
  createdAtTo,
  limit,
  offset,
  types,
  clientSMSNumber,
  clientCallNumber,
}) => {
  let type = '';
  if (types?.length) {
    types.forEach(t => {
      type = type.concat(`&types=${t}`);
    });
  }

  let taskIdQuery = '';
  if (taskIds)
    taskIds.forEach((taskId, index) => {
      index === taskIds.length - 1
        ? (taskIdQuery += `&task_ids=${taskId}`)
        : (taskIdQuery += `&task_ids=${taskId}&`);
    });

  const query = `?offset=${offset ? offset : 0}&limit=${limit ? limit : 20}${
    createdAtFrom ? `&created_at_from=${createdAtFrom}` : ''
  }${createdAtTo ? `&created_at_to=${createdAtTo}` : ''}${
    clientSMSNumber ? `&client_sms_number=%2B1${clientSMSNumber}` : ''
  }${clientCallNumber ? `&client_call_number=%2B1${clientCallNumber}` : ''}${
    type ? `${type}` : ''
  }${taskIds ? `${taskIdQuery}` : ''}`;
  return query;
};

export const isPhoneNumberValid = number => {
  if (number && !number.match(/^(\d){10}$/gm)) return false;
  return true;
};
